if (!window.mtScriptsLoaded) {
  window.mtScriptsLoaded = true;

  var mtReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var mtInitReveal = function () {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-observed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.dataset.mtDelay || 0;
            setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) {
      el.classList.add('mt-observed');
      observer.observe(el);
    });
  };

  var mtInitMarquesinas = function () {
    document.querySelectorAll('[data-mt-marquesina]').forEach(function (wrap) {
      var pista = wrap.querySelector('.mt-resenas__pista');
      if (!pista || pista.dataset.mtCloned) return;
      pista.dataset.mtCloned = 'true';
      pista.innerHTML += pista.innerHTML;
      var velocidad = Number(wrap.dataset.mtVelocidad || 40);
      pista.style.animationDuration = velocidad + 's';
    });
  };

  var mtInitProgressBar = function () {
    if (document.querySelector('.mt-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'mt-progress';
    var fill = document.createElement('div');
    fill.className = 'mt-progress__fill';
    bar.appendChild(fill);
    document.body.appendChild(bar);
    if (mtReducedMotion.matches) return;
    var ticking = false;
    var update = function () {
      var scrollTop = window.scrollY;
      var height = document.documentElement.scrollHeight - window.innerHeight;
      var pct = height > 0 ? Math.min(100, (scrollTop / height) * 100) : 0;
      fill.style.width = pct + '%';
      ticking = false;
    };
    update();
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
  };

  var mtInitParallax = function () {
    if (mtReducedMotion.matches) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-mt-parallax]:not(.mt-parallax-bound)'));
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('mt-parallax-bound'); });
    var ticking = false;
    var update = function () {
      var viewportH = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportH) return;
        var center = rect.top + rect.height / 2 - viewportH / 2;
        var intensity = Number(el.dataset.mtParallax) || 0.08;
        var offset = Math.max(-40, Math.min(40, center * intensity * -1));
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    update();
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
  };

  var mtInitTilt = function () {
    if (mtReducedMotion.matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('[data-mt-tilt]:not(.mt-tilt-bound)').forEach(function (card) {
      card.classList.add('mt-tilt-bound');
      var strength = Number(card.dataset.mtTilt) || 8;
      card.addEventListener('pointermove', function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(700px) rotateX(' + (py * -strength).toFixed(2) + 'deg) rotateY(' +
          (px * strength).toFixed(2) + 'deg) translateY(-4px)';
      });
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  };

  var mtInitFaqAnimado = function () {
    document.querySelectorAll('.mt-faq__item:not(.mt-faq-bound)').forEach(function (item) {
      item.classList.add('mt-faq-bound');
      var respuesta = item.querySelector('.mt-faq__respuesta');
      var pregunta = item.querySelector('.mt-faq__pregunta');
      if (!respuesta || !pregunta) return;
      pregunta.addEventListener('click', function (e) {
        e.preventDefault();
        var abierto = item.hasAttribute('open');
        if (abierto) {
          respuesta.style.height = respuesta.scrollHeight + 'px';
          requestAnimationFrame(function () {
            respuesta.style.height = '0px';
          });
          respuesta.addEventListener(
            'transitionend',
            function () {
              item.removeAttribute('open');
              respuesta.style.height = '';
            },
            { once: true }
          );
        } else {
          item.setAttribute('open', '');
          respuesta.style.height = '0px';
          requestAnimationFrame(function () {
            respuesta.style.height = respuesta.scrollHeight + 'px';
          });
          respuesta.addEventListener(
            'transitionend',
            function () {
              respuesta.style.height = '';
            },
            { once: true }
          );
        }
      });
    });
  };

  window.mtInitAll = function () {
    mtInitReveal();
    mtInitMarquesinas();
    mtInitProgressBar();
    mtInitParallax();
    mtInitTilt();
    mtInitFaqAnimado();
  };

  document.addEventListener('DOMContentLoaded', window.mtInitAll);
  document.addEventListener('shopify:section:load', window.mtInitAll);
} else if (document.readyState !== 'loading') {
  window.mtInitAll && window.mtInitAll();
}
